





















import { Component, Vue, Provide } from 'vue-property-decorator';

@Component({
    components: {}
})
export default class ColorSuggestion extends Vue {
    @Provide()
    backgrounds: string[] = [
        'transparent',
        'linear-gradient(180deg, #523FC2 0%, #A367CB 48.44%, #FA99D2 100%)',
        'radial-gradient(50% 50% at 50% 50%, #BC969D 0%, #AD6E8D 51.56%, #774E6D 100%)',
        'linear-gradient(225deg, #B1B2C4 0%, #8182A0 34.9%, #4B4C75 100%)',
        'linear-gradient(180deg, #CAEAE9 0%, #9DD4D1 100%)'
    ];
}
